
import BottomNav from '../../components/base/BottomNav';
import Header from '../../components/base/Header';

export default function Gamificacao() {
  const badges = [
    { icon: 'ri-star-fill', name: 'Primeira Estrela', descricao: 'Complete sua primeira mentoria', conquistado: true, color: 'text-yellow-500', bg: 'bg-yellow-100' },
    { icon: 'ri-fire-fill', name: 'Sequência de 7 Dias', descricao: 'Acesse a plataforma por 7 dias seguidos', conquistado: true, color: 'text-orange-500', bg: 'bg-orange-100' },
    { icon: 'ri-trophy-fill', name: 'Top 10', descricao: 'Entre no ranking dos 10 melhores', conquistado: true, color: 'text-purple-500', bg: 'bg-purple-100' },
    { icon: 'ri-leaf-fill', name: 'Eco Warrior', descricao: 'Resgate 5 recompensas sustentáveis', conquistado: true, color: 'text-green-500', bg: 'bg-green-100' },
    { icon: 'ri-book-fill', name: 'Estudioso', descricao: 'Complete 50 mentorias', conquistado: false, color: 'text-blue-500', bg: 'bg-blue-100' },
    { icon: 'ri-heart-fill', name: 'Mentor Querido', descricao: 'Receba 100 avaliações positivas', conquistado: false, color: 'text-pink-500', bg: 'bg-pink-100' },
  ];

  const ranking = [
    { posicao: 1, nome: 'Ana Carolina Lima', pontos: 2850, avatar: 'AC', color: 'from-yellow-400 to-yellow-500' },
    { posicao: 2, nome: 'João Pedro Santos', pontos: 2640, avatar: 'JP', color: 'from-gray-300 to-gray-400' },
    { posicao: 3, nome: 'Beatriz Oliveira', pontos: 2420, avatar: 'BO', color: 'from-orange-400 to-orange-500' },
    { posicao: 4, nome: 'Maria Silva', pontos: 1250, avatar: 'MS', color: 'from-purple-500 to-pink-500', isUser: true },
    { posicao: 5, nome: 'Carlos Eduardo Silva', pontos: 1180, avatar: 'CE', color: 'from-blue-500 to-cyan-500' },
  ];

  const missoes = [
    { titulo: 'Complete 3 mentorias hoje', progresso: 2, total: 3, pontos: 50, icon: 'ri-message-3-line', color: 'from-blue-500 to-cyan-500' },
    { titulo: 'Ajude 5 colegas esta semana', progresso: 3, total: 5, pontos: 100, icon: 'ri-user-heart-line', color: 'from-purple-500 to-pink-500' },
    { titulo: 'Estude por 2 horas', progresso: 1.5, total: 2, pontos: 75, icon: 'ri-time-line', color: 'from-green-500 to-emerald-500' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-pink-50 to-purple-50 pb-20">
      <Header title="Gamificação" />

      <div className="pt-16 px-6">
        {/* User Points */}
        <div className="mt-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-3xl shadow-lg p-6 text-white">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-sm opacity-90">Seus Pontos</p>
              <h2 className="text-4xl font-bold mt-1">1,250</h2>
            </div>
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-trophy-fill text-3xl" />
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <i className="ri-arrow-up-line" />
            <span>+150 pontos esta semana</span>
          </div>
        </div>

        {/* Missões Diárias */}
        <div className="mt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Missões Diárias</h3>
          <div className="space-y-3">
            {missoes.map((missao, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md p-4">
                <div className="flex items-start gap-4 mb-3">
                  <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br ${missao.color} rounded-xl flex-shrink-0`}>
                    <i className={`${missao.icon} text-xl text-white`} />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-gray-800 mb-1">{missao.titulo}</h4>
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-coin-line text-amber-500" />
                      <span className="font-semibold">+{missao.pontos} pontos</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-1 bg-gray-200 rounded-full h-2">
                    <div
                      className={`bg-gradient-to-r ${missao.color} h-2 rounded-full transition-all`}
                      style={{ width: `${(missao.progresso / missao.total) * 100}%` }}
                    />
                  </div>
                  <span className="text-sm font-semibold text-gray-600">
                    {missao.progresso}/{missao.total}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Badges */}
        <div className="mt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Conquistas</h3>
          <div className="grid grid-cols-2 gap-3">
            {badges.map((badge, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-md p-4 ${
                  !badge.conquistado && 'opacity-50'
                }`}
              >
                <div className={`w-14 h-14 flex items-center justify-center ${badge.bg} rounded-2xl mb-3 mx-auto`}>
                  <i className={`${badge.icon} text-3xl ${badge.color}`} />
                </div>
                <h4 className="font-bold text-gray-800 text-sm text-center mb-1">
                  {badge.name}
                </h4>
                <p className="text-xs text-gray-600 text-center">{badge.descricao}</p>
                {badge.conquistado && (
                  <div className="mt-2 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-green-500 text-lg" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Ranking */}
        <div className="mt-6 mb-6">
          <h3 className="text-lg font-bold text-gray-800 mb-3">Ranking Semanal</h3>
          <div className="space-y-3">
            {ranking.map((user, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-md p-4 flex items-center gap-4 ${
                  user.isUser && 'ring-2 ring-purple-500'
                }`}
              >
                <div className={`w-10 h-10 flex items-center justify-center bg-gradient-to-br ${user.color} rounded-full text-white font-bold flex-shrink-0`}>
                  {user.posicao}
                </div>
                <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br ${user.color} rounded-full text-white font-bold flex-shrink-0`}>
                  {user.avatar}
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-gray-800">{user.nome}</h4>
                  <div className="flex items-center gap-1 text-sm text-gray-600">
                    <i className="ri-coin-line text-amber-500" />
                    <span className="font-semibold">{user.pontos} pontos</span>
                  </div>
                </div>
                {user.posicao <= 3 && (
                  <i className="ri-trophy-fill text-2xl text-amber-500" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
